import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { INotification } from '../../../models/Notification';
import { AppService } from '../../../services/app.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
    selector: 'app-notification-form',
    templateUrl: './notification-form.component.html'
})
export class NotificationFormComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: NotificationService,
        private route: ActivatedRoute
    ) { }

    data: INotification;
    error?: string;

    ngOnInit() {
        const id = +this.route.snapshot.params['id'];

        this.app.addLoading(this.service.getById(id)).subscribe(data => {
            this.data = data;
        }, err => {
            this.error = this.app.getHttpResponseError(err);
        });
    }
}
